import { render } from "./initialValue.vue?vue&type=template&id=8f36128e"
import script from "./initialValue.vue?vue&type=script&lang=js"
export * from "./initialValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__